import {useState} from 'react';
import {Button, Container, Nav, Navbar} from 'react-bootstrap';
import {Calendar, House} from 'react-bootstrap-icons';
import {useNavigate} from 'react-router-dom';
import styles from './Header.module.scss';

function MainHeader({showTopHeader = true}) {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);

    const navItems = [
        {path: '/', label: 'Главная', icon: <House size={16} className="me-1"/>},
        {path: '/services', label: 'Услуги'},
    ];

    return (
        <Navbar
            expand="lg"
            className={`${styles.mainHeader} ${showTopHeader ? styles.withTopHeader : ''}`}
            expanded={expanded}
            onToggle={setExpanded}
        >
            <Container>
                {/* Логотип */}
                <Navbar.Brand
                    onClick={() => navigate('/')}
                    className={styles.logo}
                    style={{cursor: 'pointer'}}
                >
                    <div className={styles.logoContainer}>
                        <span className={styles.logoText}>Ветеринарная клиника</span>
                        <span className={styles.logoSubtext}>ЗООДОКТОР</span>
                    </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="main-navbar-nav"/>

                <Navbar.Collapse id="main-navbar-nav">
                    {/* Навигация */}
                    <Nav className={`ms-auto ${styles.navLinks}`}>
                        {navItems.map((item) => (
                            <Nav.Link
                                key={item.path}
                                onClick={() => {
                                    navigate(item.path);
                                    setExpanded(false);
                                }}
                                className={styles.navLink}
                            >
                                {item.icon && item.icon}
                                {item.label}
                            </Nav.Link>
                        ))}
                    </Nav>

                    {/* Кнопка записи */}
                    <Button
                        variant="primary"
                        className={styles.appointmentBtn}
                        onClick={() => navigate('/online_record')}
                    >
                        <Calendar className="me-2" size={16}/>
                        Записаться
                    </Button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MainHeader;